module.exports = __webpack_public_path__ + "img/main5.a8e3e826.png";